import React from "react";
import { FiCheck, FiX, FiEye } from "react-icons/fi";

const approveRejectIcons = ({
  onApprove,
  onReject,
  approveLoading,
  approveLabel,
  rejectLabel,
}) => (
  <>
    <FiCheck
      className="cursor-pointer text-grey"
      style={{
        fontSize: "20px",
        cursor: "pointer",
        opacity: approveLoading ? 0.5 : 1,
        pointerEvents: approveLoading ? "none" : "auto",
      }}
      title={approveLabel || "Onayla"}
      onClick={onApprove}
    />
    <FiX
      className="cursor-pointer text-grey"
      style={{ fontSize: "20px", cursor: "pointer" }}
      title={rejectLabel || "Reddet"}
      onClick={onReject}
    />
  </>
);

/** Shared row action icons for approval flows. */
const ApprovalRowActions = ({
  canAct = false,
  readOnly = false,
  onView,
  onApprove,
  onReject,
  approveLoading = false,
  approveLabel,
  rejectLabel,
  actionsPosition = "after",
  children,
}) => (
  <div
    className="approval-row-actions d-flex align-items-center"
    style={{ gap: "8px" }}
  >
    {canAct &&
      !readOnly &&
      actionsPosition === "before" &&
      approveRejectIcons({
        onApprove,
        onReject,
        approveLoading,
        approveLabel,
        rejectLabel,
      })}
    <FiEye
      className="cursor-pointer text-grey"
      style={{ fontSize: "20px", cursor: "pointer" }}
      title="Detay"
      onClick={onView}
    />
    {canAct &&
      !readOnly &&
      actionsPosition === "after" &&
      approveRejectIcons({
        onApprove,
        onReject,
        approveLoading,
        approveLabel,
        rejectLabel,
      })}
    {children}
  </div>
);

export default ApprovalRowActions;
